export default "__VITE_ASSET__749b2399__"